export default "__VITE_ASSET__947b29fd__"